import RwCustodianService from '@advisor/rwSdk/CustodianService';
import BankLinking from '@advisor/models/store/bankLinking/index';
import exceptionHandler from '@advisor/util/exceptionHandler';
import {addRiaComponentTo} from '@advisor/util/store/paramInjects';
import ClientService from '@advisor/rwSdk/ClientService';
import CloudConvertServices from '@advisor/rwSdk/CloudConvertService';
import {uploadDocumentFlag} from '@advisor/remote-config';
import {mapDocumentResponse} from '@advisor/util/documentResponseMapper';

export const stateObj = function () {
  return new BankLinking();
};

export const actions = {
  async getBankLinkingStatusCount({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwCustodianService.getStatusWiseCountOfBankAccountIdentityRequests(fullPayload).catch(
        (error) => {
          throw error;
        }
      );

      const {actionRequired, approved, rejected} = sdkResponse;
      const tabsCount = {
        'action-required-requests': actionRequired,
        'approved-requests': approved,
        'rejected-requests': rejected,
      };

      commit('SET_BANK_LINKING_STATUS_COUNT', tabsCount);

      return Promise.resolve(tabsCount);
    } catch (error) {
      exceptionHandler.handleGenericException('bankLinking.getBankLinkingStatusCount', error);

      return Promise.reject(error);
    }
  },
  async getBankLinkingRequestsListData({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo({...payload}, rootState.settings.default);

      const sdkResponse = await RwCustodianService.getBankAccountIdentityRequestsForAdvisor(fullPayload).catch((error) => {
        throw error;
      });

      commit('SET_BANK_LINK_REQUESTS_LIST_DATA', sdkResponse.data);

      commit('SET_BANK_LINK_REQUESTS_TOTAL_COUNT', sdkResponse.count);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('bankLinking.getBankLinkingRequestsListData', error);

      return Promise.reject(error);
    }
  },
  async updateBankAccountIdentityDocumentRequest({commit, rootState}, payload) {
    try {
      const {identityDocumentRequestId} = payload;
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwCustodianService.updateBankAccountIdentityDocumentRequest(fullPayload).catch((error) => {
        throw error;
      });

      commit('ADD_UPLOADED_DOCUMENT_ID', identityDocumentRequestId);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('bankLinking.updateBankAccountIdentityDocumentRequest', error);

      return Promise.reject(error);
    }
  },
  async updateBankAccountIdentityRequest({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwCustodianService.updateBankAccountIdentityRequest(fullPayload).catch((error) => {
        throw error;
      });

      commit('SET_UPDATED_BANK_LINK_DETAILS', sdkResponse);
      commit('SET_FLAG_TO_REFRESH_DATA_LIST', true);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('bankLinking.updateBankAccountIdentityRequest', error);

      return Promise.reject(error);
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async fetchBankLinkingDetailsByReqId({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);

      const sdkResponse = await RwCustodianService.getBankAccountIdentityRequestsForClUser(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse[0]);
    } catch (error) {
      exceptionHandler.handleGenericException('bankLinking.fetchBankLinkingDetailsByReqId', error);

      return Promise.reject(error);
    }
  },
  async uploadClientDocument({rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);
      let sdkResponse;

      // depending on feature flag status, the respective service will be called
      if (await uploadDocumentFlag()) {
        sdkResponse = await CloudConvertServices.scanAndUploadDocument(fullPayload).catch((error) => {
          throw error;
        });
        const mappedResponse = mapDocumentResponse(sdkResponse.fileInfo);

        return Promise.resolve(mappedResponse);
      }

      sdkResponse = await ClientService.uploadDocumentByBase64(fullPayload).catch((error) => {
        throw error;
      });

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('bankLinking.uploadClientDocument', error);
      throw error;
    }
  },
  resetRefreshListDataFlag({commit}, flag) {
    commit('SET_FLAG_TO_REFRESH_DATA_LIST', flag);
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getOpenedAccounts({commit}, payload) {
    try {
      const response = await RwCustodianService.getCustodianAccounts(payload).catch((error) => {
        throw error;
      });

      return Promise.resolve(response);
    } catch (error) {
      exceptionHandler.handleGenericException('bankLinking.getOpenedAccounts', error);

      return Promise.reject(error);
    }
  },
};

export const mutations = {
  SET_BANK_LINKING_STATUS_COUNT(state, payload) {
    state.statusCount = payload;
  },
  SET_UPDATED_BANK_LINK_DETAILS(state, payload) {
    state.updatedBankLinkDetails = payload;
  },
  SET_BANK_LINK_REQUESTS_LIST_DATA(state, payload) {
    state.bankLinkingRequestsData = payload;
  },
  SET_BANK_LINK_REQUESTS_TOTAL_COUNT(state, payload) {
    state.totalCount = payload;
  },
  SET_FLAG_TO_REFRESH_DATA_LIST(state, payload) {
    state.refreshListData = payload;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  actions,
  // getters,
  mutations,
};
